import * as gfunctions from '../../../js/generalFunctions';

CCL.xDining = {
  autoload: [
    ['toggleDayTime', $('#xdiningAtcModal').length > 0],
    ['addToCartxDining', $('#xdiningAtcModal').length > 0],
    ['arrowSelect', $('body').length > 0],
    ['selectOwner', $('.pdp-xdining-btn').length > 0],

    ['adultIncrement', $('#xdiningAtcModal').length > 0],
    ['childIncrement', $('#xdiningAtcModal').length > 0],
    ['adultDecrement', $('#xdiningAtcModal').length > 0],
    ['childDecrement', $('#xdiningAtcModal').length > 0]
  ],

  intialResponse: {},
  selectedDayID: '',
  selectedTimeID: '',

  selectOwner() {
    setTimeout(() => {
      const buyerId = $('.selected-buyer-id')[0].dataset.selectedbuyerid;
      $(`.guests-check input[data-guestid='${buyerId}']`).trigger('click');
    }, 300);
  },

  toggleDayTime() {
    $('body').on('click keypress', '.custom-control.custom-checkbox > input', (e) => {
      $(e.target).parents('.xdining-parent').find('.day-time-wrap').removeClass('show');
      if ($('.c-pdp-template-reserve-dining').length) {
        $('.atc-xdining').hide();
      }

      $(e.target).parents('.xdining-parent').find('.guests-check').removeClass('dining-guest-div-disable');
      $(e.target).parents('.xdining-parent').find('.guests-check input').removeClass('dining-guest-disable');

      $(e.target).parents('.xdining-parent').find('.stateroom-check').removeClass('dining-div-disable');
      $(e.target).parents('.xdining-parent').find('.stateroom-check input').removeClass('dining-stateroom-disable');

      $(e.target).parents('.xdining-parent').find('.red-text').empty();

      setTimeout(() => {
        this.reservationOwner(e);
        this.disableDayBtn(e);
      }, 300);
    });

    // on owner link click
    $('body').on('click keypress', '.owner-link', (e) => {
      e.stopPropagation();
      e.preventDefault();
      $(e.target).parents('.xdining-parent').find('.day-time-wrap').removeClass('show');
      $(e.target).parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
      $(e.target).parents('.xdining-parent').find('.saveEditCartStateroom').attr('disabled', 'disabled');

      const oldGuestName = $(e.target)
        .parents('.guests-check')
        .find('.dining-guest-error-msg')[0].dataset.guestname;

      const newGuestName = $(e.target).parents('.xdining-parent').find('.reservation-text').parents('.guests-check')
        .find('.dining-guest-error-msg')[0].dataset.guestname;

      $(e.target).parents('.xdining-parent').find('.reservation-text').replaceWith(`<a href="#" class="owner-link" tabindex="0" aria-label="set ${newGuestName} as a reservation owner" role="button">Set as Reservation Owner</a>`);
      $(e.target).parents('.xdining-parent').find('.ccl_tooltip').remove();
      $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid = $(e.target).parents('.guests-check').find('input.custom-control-input')[0].dataset.guestid;

      $(e.target).parents('.xdining-parent').find('.guests-check').removeClass('dining-guest-div-disable');
      $(e.target).parents('.xdining-parent').find('.guests-check input').removeClass('dining-guest-disable');

      $(e.target).parents('.xdining-parent').find('.stateroom-check').removeClass('dining-div-disable');
      $(e.target).parents('.xdining-parent').find('.stateroom-check input').removeClass('dining-stateroom-disable');

      $(e.target).parents('.xdining-parent').find('.red-text').empty();

      $(e.target).parents('.guests-check input').focus();
      $(e.target).parents('.xdining-parent').find('.owner-change-alert').html(`${oldGuestName} is new reservation owner`);

      $(e.target).parents('.guests-check')
        .find('.owner-div')
        .empty()
        .html(`<span class="reservation-text">Reservation Owner</span>
        <div class="ccl_tooltip" role="button" aria-describedby="reservation-tooltip" tabindex="0" aria-label="Reservation owner has ability to manage dining reservation">
          <img src="/_ui/responsive/ccl/assets/icons/Oval 3 Copy 2.svg" height="12px" width="12px" alt="">
          <div class="tooltip_text" id="reservation-tooltip" aria-live="assertive">
              Reservation owner has ability to manage dining reservation.
          </div>
        </div>`);
    });


    // On select day and time button click
    $('body').on('click keypress', '.selection-btn', (e) => {
      gfunctions.showLoader();
      const checkedLength = $(e.target).parents('.xdining-parent').find('.custom-control.custom-checkbox.guests-check > input[type="checkbox"]:checked').length;
      const productId = e.target.dataset.productid ? e.target.dataset.productid : $('#parent-product-code').val();
      const csrf = $('.atc-xdining').data('csrf') ? $('.atc-xdining').data('csrf') : $('#csrfSessionToken').data('csrf');
      const { selectedbuyerid } = e.target.dataset;
      const dataObj = {
        code: productId,
        count: parseInt(checkedLength, 10) + parseInt($('.child-quantity-input').val(), 10) + parseInt($('.adult-quantity-input').val(), 10),
        buyerId: selectedbuyerid
      };
      if (e.target.dataset.iscart && e.target.dataset.iscart === 'true') {
        dataObj.cartPage = true;
        dataObj.serviceTimeSlot = $(e.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap')[0].dataset.servicetimeslot;
        dataObj.oldBuyerId = $(e.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap')[0].dataset.buyerid;

        // Loop through selected guests and pass to the api
        const guestIdsArray = [];
        if ($(e.target).parents('.xdining-parent').find('.custom-checkbox .guests-check input[type="checkbox"]').length) {
          $(e.target).parents('.xdining-parent').find('.custom-checkbox .guests-check input[type="checkbox"]:checked').each((i, elem) => {
            if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
              guestIdsArray.push(elem.getAttribute('data-guestid'));
            }
          });
          dataObj.guestIds = guestIdsArray;
        }
      } else {
        const guestIdsArray = $(e.target)
          .parents('.xdining-parent')
          .find('.atc-xdining')
          .attr('data-guestIds') ?
          $(e.target)
            .parents('.xdining-parent')
            .find('.atc-xdining')
            .attr('data-guestIds')
            .split(',') : [];

        dataObj.guestIds = guestIdsArray;
      }
      let ajaxUrl = '';
      let ajaxType = '';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/json-data/dining-daytime.json';
        ajaxType = 'GET';
      } else {
        ajaxUrl = '/shop/product/xDiningDateTime';
        ajaxType = 'POST';
      }
      $.ajax({
        type: ajaxType,
        url: ajaxUrl,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(dataObj),
        headers: {
          CSRFToken: csrf
        }
      }).done((res) => {
        gfunctions.hideLoader();
        $('.api-error').empty();
        if (res.xdininginventorydata && res.xdininginventorydata.failedInventoryCallMessage) {
          $(e.target).parents('.xdining-parent').find('.api-error').html(res.xdininginventorydata.failedInventoryCallMessage);
        } else if (res.xdininginventorydata && res.xdininginventorydata.emptyInventoryMessage) {
          if ($('.dining-Atc-modal-body .cart-card-body').length) {
            $('.dining-Atc-modal-body .cart-card-body').find('.red-text.api-error').text(res.xdininginventorydata.emptyInventoryMessage);
          } else {
            $('.c-pdp-template-reserve-dining .c-pdp-card').find('.red-text.api-error').text(res.xdininginventorydata.emptyInventoryMessage);
          }
        } else {
          this.intialResponse = res;
          if ($(e.target).parents('.xdining-parent').find('.cart-card-body').length) {
            $(e.target).parents('.xdining-parent')
              .find('.cart-card-body')
              .find('.redtext')
              .text('');
          } else {
            $('.c-pdp-template-reserve-dining .c-pdp-card').find('.redtext').text('');
          }

          $(e.target).parents('.xdining-parent').find('.selection-btn').attr('disabled', 'disabled');
          $(e.target).parents('.xdining-parent').find('.day-time-wrap').addClass('show');
          if ($('.c-pdp-template-reserve-dining').length) {
            $('.atc-xdining').show();
          }
          $(e.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').removeAttr('disabled');
          this.populateDayDropdown(res.xdininginventorydata, e);
          this.dropdownSelect();
        }
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('Something went wrong in select button ajax');
      });
    });
  },

  reservationOwner(e) {
    if ($(e.target).parents('.xdining-parent').find('.selected-buyer-id').length) {
      const seletedBuyerId = $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid;
      const priorityList = $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.buyeridprioritypassengers;

      if (priorityList !== '') {
        let looping = true;
        const priorityArr = priorityList.split(',');

        if (($(e.target).hasClass('xdining-parent-check') && !$(e.target)[0].checked) || ($(e.target)[0].dataset.guestid && seletedBuyerId === $(e.target)[0].dataset.guestid)) {
          $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid = '';
        }

        priorityArr.forEach(element => {
          if ($(e.target).parents('.xdining-parent').find(`[data-guestid='${element}']`)[0].checked) {
            $(e.target)
              .parents('.xdining-parent')
              .find(`[data-guestid='${element}']`)
              .parents('.guests-check')
              .find('.owner-link')
              .attr('tabindex', '0')
              .removeClass('disabled');
            if (looping && $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid === '') {
              $(e.target)
                .parents('.xdining-parent')
                .find(`[data-guestid='${element}']`)
                .parents('.guests-check')
                .find('.owner-div')
                .empty()
                .html(`<span class="reservation-text">Reservation Owner</span>
              <div class="ccl_tooltip" role="button" tabindex="0" aria-describedby="reservation-tooltip" aria-label="Reservation owner has ability to manage dining reservation">
                  <img src="/_ui/responsive/ccl/assets/icons/Oval 3 Copy 2.svg" height="12px" width="12px" alt="">
                  <div class="tooltip_text" id="reservaion-tooltip" aria-live="assertive">
                      Reservation owner has ability to manage dining reservation.
                  </div>
              </div>`);
              $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid = element;
              looping = false;
            }
          } else {
            const guestName = $(e.target)
              .parents('.xdining-parent')
              .find(`[data-guestid='${element}']`)
              .parents('.guests-check')
              .find('.dining-guest-error-msg')[0].dataset.guestname;
            $(e.target)
              .parents('.xdining-parent')
              .find(`[data-guestid='${element}']`)
              .parents('.guests-check')
              .find('.owner-div')
              .empty()
              .html(`<a href="#" aria-label="set ${guestName} as a reservation owner" class="owner-link disabled" tabindex="-1" role="button">Set as Reservation Owner</a>`);
          }
        });
      } else {
        $('.all-conflict-msg').html('At least one guest must be 21 or over');
      }
    }
  },

  populateDayDropdown(diningData, event) {
    let daysArray = [];
    $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-menu').empty();

    /* eslint-disable */
    for (let index = 1; index <= Object.keys(diningData.inventoriesForDay).length; index++) {
      $.each(diningData.inventoriesForDay[`Day_${index}`], (ind, value) => {
        const dateSplit = value.availability.substring(0, 8);
        daysArray.push(dateSplit);
      });
    }
    /* eslint-enable */
    daysArray = Array.from(new Set(daysArray));

    $.each(daysArray, (i, val) => {
      const year = val.substring(0, 4);
      const month = val.substring(4, 6);
      const day = val.substring(6, 8);
      const date = `${new Date(year, month - 1, day)}`;
      const dateArray = date.split(' ');
      const formatDate = `${dateArray[0]}, ${dateArray[1]} ${dateArray[2]}`;
      const activeClass = i === 0 ? 'active' : '';
      let disabledClass = '';
      disabledClass = diningData.inventoriesForDay[`Day_${i + 1}`].some(x => x.status.toLowerCase() === 'available') ? '' : 'disabled-item';
      const dayHtml = `<button id='dayBtn${i}' class="dropdown-item ${activeClass} ${disabledClass}"
      data-dayid="Day_${i + 1}" type="button">Day ${i + 1}, ${formatDate}</button>`;
      if (i === 0) {
        const disabledClassBtn = diningData.inventoriesForDay[`Day_${i + 1}`].some(x => x.status.toLowerCase() === 'available') ? '' : 'blurred';

        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .select-day-item').addClass(disabledClassBtn);

        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').text(`Day ${i + 1}, ${formatDate}`);
        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').attr('aria-label', `Day ${i + 1}, ${formatDate} selected`);
        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').attr('aria-label', `Day ${i + 1}, ${formatDate} selected`);
        this.populateTimeDropdown(diningData.inventoriesForDay.Day_1, event);
      }
      $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-menu').append(dayHtml);
    });

    if (this.selectedDayID !== '' && this.selectedTimeID !== '') {
      $(`.select-day-dropdown.xdining #${this.selectedDayID}`).trigger('click');
      $(`.select-time-dropdown.xdining #${this.selectedTimeID}`).trigger('click');

      this.selectedDayID = '';
      this.selectedTimeID = '';
    }
  },

  populateTimeDropdown(dayInventory, event) {
    if (dayInventory && dayInventory.filter(x => x.timeslot).length) {
      $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-menu').empty();
      $(event.target).parents('.xdining-parent').find('.notimeMessage').hide();
      $(event.target).parents('.xdining-parent').find('.select-time-item').show();
      $.each(dayInventory, (i, val) => {
        const activeClass = i === 0 ? 'active' : '';
        const disabledClass = val.status.toLowerCase() === 'available' ? '' : 'disabled-item';
        const soldOutHtml = val.status.toLowerCase() === 'available' ? '' : '<span class="red-text">&nbsp; Sold Out</span>';
        const timeHtml = `<button id='timeBtn${i}' data-availability='${val.availability}' data-status='${val.status}'
        class="dropdown-item ${activeClass} ${disabledClass}"
        type="button">${val.timeslot} ${soldOutHtml}</button>`;
        if (i === 0) {
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').text(val.timeslot);

          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('aria-label', `${val.timeslot} selected`);
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').attr('aria-label', `${val.timeslot} selected`);
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot', `${val.availability}`);
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-soldout', `${val.status}`);
        }
        $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-menu').append(timeHtml);
      });

      this.soldoutCondition(event);
    } else {
      const errMsg = 'Please check for availability on other days or explore other dining options.';
      $(event.target).parents('.xdining-parent').find('.select-time-item').hide();
      $(event.target).parents('.xdining-parent').find('.dining-atc-modal-dialog .sold-out-div').removeClass('show');
      $(event.target)
        .parents('.xdining-parent')
        .find('.notimeMessage')
        .text(errMsg)
        .show();
      $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
      $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
    }
  },

  disableDayBtn(event) {
    const checkedLength = $(event.target).parents('.xdining-parent').find('.custom-control.custom-checkbox.guests-check > input[type="checkbox"]:checked').length;
    const selectedBuyer = $(event.target).parents('.xdining-parent').find('.selected-buyer-id')[0];
    const priorityList = selectedBuyer && selectedBuyer.dataset.buyeridprioritypassengers;
    $('.atc-xdining').attr('disabled', 'disabled');
    $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
    if (checkedLength > 0 && priorityList && priorityList !== '') {
      $(event.target).parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');

      this.enableButton($('.child-increment-btn'));
      this.enableButton($('.child-decrement-btn'));
      this.enableButton($('.adult-increment-btn'));
      this.enableButton($('.adult-decrement-btn'));
    } else {
      $(event.target).parents('.xdining-parent').find('.selection-btn').attr('disabled', 'disabled');

      this.disableButton($('.child-increment-btn'));
      this.disableButton($('.child-decrement-btn'));
      this.disableButton($('.adult-increment-btn'));
      this.disableButton($('.adult-decrement-btn'));
      $(event.target).parents('.xdining-parent').find('.day-time-wrap').removeClass('show');
      if ($('.c-pdp-template-reserve-dining').length) {
        $('.atc-xdining').hide();
      }
    }
  },

  enableButton(button) {
    button.css('opacity', '1');
    button.css('pointer-events', 'auto');
    button.prop('disabled', false);
  },

  disableButton(button) {
    button.css('opacity', '0.5');
    button.css('pointer-events', 'none');
    button.prop('disabled', true);
  },

  dropdownSelect() {
    $('.select-day-dropdown.xdining .dropdown-toggle').attr('aria-live', 'assertive');
    $('.select-time-dropdown.xdining .dropdown-toggle').attr('aria-live', 'assertive');

    // On click of days dropdown item
    $('body').on('click keypress', '.select-day-dropdown.xdining .dropdown-item', (e) => {
      $(e.target).parents('.xdining-parent').find('.sold-out-div').removeClass('show');
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').removeClass('blurred');
      if ($(e.currentTarget).hasClass('disabled-item')) {
        $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').addClass('blurred');
      }
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').text(e.currentTarget.innerText);
      $(e.target).parents('.xdining-parent').find('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
      const selectedDay = $(e.currentTarget).attr('data-dayid');
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').attr('data-selectedday', `${selectedDay}`);
      this.populateTimeDropdown(this.intialResponse.xdininginventorydata.inventoriesForDay[selectedDay], e);
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').addClass('ada-highlighted');
      $('.select-day-dropdown.xdining .dropdown-toggle').attr('aria-label', `Select day: ${e.currentTarget.innerText} selected`);
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').attr('aria-label', `Select day: ${e.currentTarget.innerText} selected`);
      setTimeout(() => {
        $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').focus();
      }, 100);
    });

    // On click of time dropdown item
    $('body').on('click keypress', '.select-time-dropdown.xdining .dropdown-item', (e) => {
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').html(e.currentTarget.innerHTML);
      const selectedTime = e.currentTarget.dataset.availability;
      const { status } = e.currentTarget.dataset;
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot', `${selectedTime}`);
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-soldout', `${status}`);
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').addClass('ada-highlighted');
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('aria-label', `Select Time: ${e.currentTarget.innerText} selected`);
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').attr('aria-label', `Select Time: ${e.currentTarget.innerText} selected`);
      setTimeout(() => {
        $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').focus();
      }, 100);
      this.soldoutCondition(e);
    });
  },

  arrowSelect() {
    $('body').on('click keypress', '.drop-icon-href', (e) => {
      if ($(e.target).attr('aria-expanded') === 'true') {
        $(e.target).attr('aria-label', 'select to expand guest view');
        $(e.target).attr('aria-expanded', 'false');
      } else {
        $(e.target).attr('aria-label', 'select to collapse guest view');
        $(e.target).attr('aria-expanded', 'true');
      }

      setTimeout(() => {
        $(e.target).addClass('ada-highlighted');
        $(e.target).focus();
      }, 2000);
    });
  },

  soldoutCondition(event) {
    this.showConflicts(event);
  },


  // Show conflicts messages on CLP modal & PDP & Cart
  showConflicts(event) {
    const selectedTimeSlot = $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot');
    const oldTimeSlot = $(event.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap').attr('data-servicetimeslot');

    const buyerId = $(event.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap').attr('data-buyerid');


    $(event.target).parents('.xdining-parent').find('.sold-out-div').removeClass('show');
    const soldoutData = $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-soldout');
    if (soldoutData.toLowerCase() === 'sold out' || soldoutData.toLowerCase() === 'not available') {
      // Empty all messages if we have sold out condition
      $(event.target).parents('.xdining-parent').find('.dining-stateroom-error-msg').empty();
      $(event.target).parents('.xdining-parent').find('.dining-guest-error-msg').empty();
      $(event.target).parents('.xdining-parent').find('.all-conflict-msg').empty();

      $(event.target).parents('.xdining-parent').find('.sold-out-div').addClass('show');
      $(event.target).parents('.xdining-parent').find('.sold-out-div .sold-out-msg').html('Sold Out');
      $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').addClass('blurred');
      $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
      $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
    } else {
      $(event.target).parents('.xdining-parent').find('.sold-out-div').removeClass('show');
      $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').removeClass('blurred');
      $(event.target).parents('.xdining-parent').find('.atc-xdining').removeAttr('disabled');

      // CHECK OF CONFLICTS ONLY IF ITS NOT SOLD OUT

      if (this.intialResponse.xdiningConflictsData) {
        if (this.intialResponse.xdiningConflictsData.xdiningConflicts && this.intialResponse.xdiningConflictsData.xdiningConflicts[selectedTimeSlot]) {
          const conflictData = this.intialResponse.xdiningConflictsData.xdiningConflicts;

          /* eslint-disable */
          // If everything is conflicting
          if (conflictData[selectedTimeSlot].allConflict) {
            $(event.target).parents('.xdining-parent').find('.stateroom-check').addClass('dining-div-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check input.parent-check').addClass('dining-stateroom-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check .guests-check input').addClass('dining-guest-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check .guests-check').addClass('dining-guest-div-disable');

            const allConflictMsg = this.intialResponse.conflictsMsgMap[conflictData[selectedTimeSlot].allConflictMsg];

            // show all conflict msg
            // if all are conflicting remove previous stateroom & guest error msgs also
            $(event.target).parents('.xdining-parent').find('.all-conflict-msg').text(allConflictMsg);
            $(event.target).parents('.xdining-parent').find('.dining-stateroom-error-msg').empty();
            $(event.target).parents('.xdining-parent').find('.dining-guest-error-msg').empty();
            $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
            $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
          } else {
            $(event.target).parents('.xdining-parent').find('.all-conflict-msg').empty();
            $(event.target).parents('.xdining-parent').find('.stateroom-check').removeClass('dining-div-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check input').removeClass('dining-stateroom-disable');

            if (conflictData[selectedTimeSlot].stateroomsConflictInfo && Object.keys(conflictData[selectedTimeSlot].stateroomsConflictInfo).length > 0) {
              // loop through all the staterooms
              $.each(conflictData[selectedTimeSlot].stateroomsConflictInfo, (i, val) => {
                const stateroomBoxId = oldTimeSlot && buyerId ? `${val.stateroomId}-${oldTimeSlot}-${buyerId}` : val.stateroomId;
                // if stateroom have conflict then add a class and show message
                if (val.stateroomConflict) {

                  // show message only if stateroom is checked
                  if ($(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).is(':checked')) {
                    $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').addClass('dining-div-disable');
                    $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).addClass('dining-stateroom-disable');

                    $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').find('.dining-guest-error-msg').empty();

                    $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').find('.guests-check input').addClass('dining-guest-disable');

                    const stateroomConflictMsg = this.intialResponse.conflictsMsgMap[val.stateroomConflictMsg];
                    $(event.target).parents('.xdining-parent').find(`#diningStateroomErrorMsg-${stateroomBoxId}`).text(stateroomConflictMsg);
                  }

                } else {
                  $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').find('.guests-check input').removeClass('dining-guest-disable');

                  $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').find('.guests-check').removeClass('dining-guest-div-disable');

                  $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').removeClass('dining-div-disable');
                  $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).removeClass('dining-stateroom-disable');
                  $(event.target).parents('.xdining-parent').find(`#diningStateroomErrorMsg-${stateroomBoxId}`).empty();
                  $(event.target).parents('.xdining-parent').find(`#${stateroomBoxId}`).parents('.stateroom-check').find('.dining-guest-error-msg').empty();

                  // check if some guests are having conflict
                  if (val.guestPerStateroomConflictInfoMap && Object.keys(val.guestPerStateroomConflictInfoMap).length > 0) {
                    $.each(val.guestPerStateroomConflictInfoMap, (guestId, guestVal) => {
                      var guestBoxId = oldTimeSlot && buyerId ? `${guestId}-${oldTimeSlot}-${buyerId}` : guestId;
                      // Guest is having conflict
                      if (guestVal !== 'noConflicts') {
                        // show guest error only if that guest is selected
                        if ($(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).is(':checked')) {
                          const guestConflictMsg = this.intialResponse.conflictsMsgMap[guestVal];
                          const guestName = $(event.target).parents('.xdining-parent').find(`#diningGuestErrorMsg-${guestBoxId}`).data('guestname');
                          $(event.target).parents('.xdining-parent').find(`#diningGuestErrorMsg-${guestBoxId}`).attr('aria-label', `${guestName}. ${guestConflictMsg}`).text(guestConflictMsg);
                          $(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).parents('.guests-check').addClass('dining-guest-div-disable');
                          $(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).addClass('dining-guest-disable');
                        } else {
                          $(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).parents('.guests-check').removeClass('dining-guest-div-disable');
                          $(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).removeClass('dining-guest-disable');
                        }
                      } else {
                        $(event.target).parents('.xdining-parent').find(`#diningGuestErrorMsg-${guestBoxId}`).empty();
                        $(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).removeClass('dining-guest-disable');
                        $(event.target).parents('.xdining-parent').find(`#${guestBoxId}`).parents('.guests-check').removeClass('dining-guest-div-disable');
                      }
                    });
                  }
                }
              });
            }
          }
          /* eslint-enable */
        }
      }

      gfunctions.pdpGetSelectedData();

      if ($(event.target).parents('.xdining-parent').find('.dining-stateroom-disable').length || $(event.target).parents('.xdining-parent').find('.dining-guest-disable').length) {
        $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
        $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
      } else {
        $(event.target).parents('.xdining-parent').find('.atc-xdining').removeAttr('disabled');
        $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').removeAttr('disabled');
      }
    }
  },

  getNumberOfSelectedGuests(eventTarget) {
    if ($('.cart-edit-stateroom').length > 0) {
      return eventTarget.closest('.cart-edit-stateroom').find('.guests-check input:checkbox:checked').length;
    }
    const guestIdsArray = eventTarget
      .parents('.xdining-parent')
      .find('.atc-xdining')
      .attr('data-guestIds') ?
      eventTarget
        .parents('.xdining-parent')
        .find('.atc-xdining')
        .attr('data-guestIds')
        .split(',') : [];
    return guestIdsArray.length;
  },

  adultIncrement() {
    $('body').on('click keypress', '.adult-increment-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        const eTarget = $(event.target);
        const eCurrentTarget = $(event.currentTarget);
        const numberOfSelectedGuests = this.getNumberOfSelectedGuests($(event.target));
        const maxCount = '12';
        const adultDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-decrement-btn');
        const adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        const childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        const childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        let adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        this.enableButton(adultDecrementBtn);
        eCurrentTarget.removeAttr('title');
        childIncrementBtn.removeAttr('title');
        if (adultVal < maxCount - childVal - numberOfSelectedGuests) {
          adultVal++;
          event.currentTarget.previousElementSibling.firstElementChild.value = adultVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', `adult quantity value is ${adultVal}`);
          eCurrentTarget.attr('aria-label', `increase adult quantity with current value ${adultVal}`);
          eTarget.parents('.btn-functions').find('.adult-decrement-btn').attr('aria-label', `decrease adult quantity with current value ${adultVal}`);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        } else {
          eCurrentTarget.attr('aria-label', `There is a max of ${maxCount} guests`);
          eCurrentTarget.attr('title', `There is a max of ${maxCount} guests`);
          this.disableButton(adultIncrementBtn);
          adultIncrementBtn.parent().find(adultDecrementBtn).addClass('ada-highlighted').focus();
        }
      }
    });
  },
  childIncrement() {
    $('body').on('click keypress', '.child-increment-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        const eTarget = $(event.target);
        const eCurrentTarget = $(event.currentTarget);
        const maxCount = '12';
        const numberOfSelectedGuests = this.getNumberOfSelectedGuests($(event.target));
        const childDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-decrement-btn');
        const adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        const childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        const adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        let childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        this.enableButton(childDecrementBtn);
        eCurrentTarget.removeAttr('title');
        adultIncrementBtn.removeAttr('title');
        if (childVal < maxCount - adultVal - numberOfSelectedGuests) {
          childVal++;
          event.currentTarget.previousElementSibling.firstElementChild.value = childVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', `child quantity value is ${childVal}`);
          eCurrentTarget.attr('aria-label', `increase child quantity with current value ${childVal}`);
          eTarget.parents('.btn-functions').find('.child-decrement-btn').attr('aria-label', `decrease child quantity with current value ${childVal}`);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        } else {
          eCurrentTarget.attr('aria-label', `There is a max of ${maxCount} guests`);
          eCurrentTarget.attr('title', `There is a max of ${maxCount} guests`);
          this.disableButton(childIncrementBtn);
          childIncrementBtn.parent().find(childDecrementBtn).addClass('ada-highlighted').focus();
        }
      }
    });
  },
  adultDecrement() {
    $('body').on('click keypress', '.adult-decrement-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        const eCurrentTarget = $(event.currentTarget);
        const eTarget = $(event.target);
        const maxCount = 12;
        const numberOfSelectedGuests = this.getNumberOfSelectedGuests($(event.target));
        const adultDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-decrement-btn');
        const adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        const childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        const childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        let adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        this.enableButton(adultIncrementBtn);
        adultIncrementBtn.removeAttr('title');
        childIncrementBtn.removeAttr('title');
        if (adultVal > 0) {
          adultVal--;
          event.currentTarget.nextElementSibling.firstElementChild.value = adultVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', `quantity value is ${adultVal}`);
          eCurrentTarget.attr('aria-label', `decrease adult quantity with current value ${adultVal}`);
          eTarget.parents('.btn-functions').find('.adult-increment-btn').attr('aria-label', `increase adult quantity with current value ${adultVal}`);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        }
        if (childVal < maxCount - adultVal - numberOfSelectedGuests) {
          this.enableButton(childIncrementBtn);
          childIncrementBtn.attr('aria-label', `increase child quantity with current value ${childVal}`);
        }
        if (adultVal <= 0) {
          adultDecrementBtn.parent().find(adultIncrementBtn).addClass('ada-highlighted').focus();
          this.disableButton(adultDecrementBtn);
        }
      }
    });
  },
  childDecrement() {
    $('body').on('click keypress', '.child-decrement-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        const eCurrentTarget = $(event.currentTarget);
        const eTarget = $(event.target);
        const numberOfSelectedGuests = this.getNumberOfSelectedGuests($(event.target));
        const maxCount = 12;
        const childDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-decrement-btn');
        const adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        const childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        const adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        let childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        this.enableButton(childIncrementBtn);
        adultIncrementBtn.removeAttr('title');
        childIncrementBtn.removeAttr('title');
        if (childVal > 0) {
          childVal--;
          event.currentTarget.nextElementSibling.firstElementChild.value = childVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', `quantity value is ${childVal}`);
          eCurrentTarget.attr('aria-label', `decrease child quantity with current value ${childVal}`);
          eTarget.parents('.btn-functions').find('.child-increment-btn').attr('aria-label', `increase child quantity with current value ${childVal}`);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        } if (adultVal < maxCount - childVal - numberOfSelectedGuests) {
          this.enableButton(adultIncrementBtn);
          adultIncrementBtn.attr('aria-label', `increase adult quantity with current value ${adultVal}`);
        } if (childVal <= 0) {
          childDecrementBtn.parent().find(childIncrementBtn).addClass('ada-highlighted').focus();
          this.disableButton(childDecrementBtn);
        }
      }
    });
  },
  addToCartxDining() {
    $('body').on('click', '.xdining-close-btn', (e) => {
      this.selectedDayID = $('.select-day-dropdown.xdining .dropdown-item.active')[0].id;
      this.selectedTimeID = $('.select-time-dropdown.xdining .dropdown-item.active')[0].id;

      $('.selection-btn').removeAttr('disabled').trigger('click');
    });

    $('body').on('click', '.atc-xdining', (e) => {
      gfunctions.showLoader();
      const csrf = $('.atc-xdining').data('csrf') ? $('.atc-xdining').data('csrf') : $('#csrfSessionToken').data('csrf');
      const targetElement = $(e.target).data('hasvariants');
      const productCodePost = $(e.target).attr('data-productid');
      const selectedTime = $('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot');
      const guestIdsArray = $(e.target).attr('data-guestIds') ? $(e.target).attr('data-guestIds').split(',') : [];
      const { selectedbuyerid } = $('.selected-buyer-id')[0].dataset;
      const childAnonymousGuests = $('.child-quantity-input').val();
      const adultAnonymousGuests = $('.adult-quantity-input').val();
      const wheelChairRequired = $('.js-wheelchair').is(':checked');
      const sendData = {
        productId: productCodePost,
        guestIds: guestIdsArray,
        timeSlot: selectedTime,
        buyerId: selectedbuyerid,
        childAnonymousGuests,
        adultAnonymousGuests,
        wheelChairRequired
      };
      const pageType = $('#pagetype').data('pagetype');
      sendData.pageType = pageType;
      if (pageType === 'CATEGORY') {
        sendData.productPosition = localStorage.getItem('productposition');
        sendData.pageNumber = localStorage.getItem('pageNumber');
        sendData.categoryName = localStorage.getItem('sascategorycode');
      }
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: ' /shop/cart/xDining/add',
          contentType: 'application/json',
          data: JSON.stringify(sendData),
          headers: {
            CSRFToken: csrf
          }
        }).done((response) => {
          gfunctions.hideLoader();
          if (response.diningError) {
            $('.diningErrorMsg').html(response.diningErrorText);
          } else if (response.addedToCart) {
            gfunctions.updateHeaderCartWidget(response);
            gfunctions.hideModal('xdiningAtcModal');
            CCL.addToCart.successModal(response);
            $('.diningErrorMsg').html('');
            if ($(e.target).hasClass('pdp-xdining-btn')) {
              $('#addToCartSuccessModal .close').addClass('xdining-close-btn');
            }
          }
        }).fail(() => {
          gfunctions.hideLoader();
          console.log('Something went wrong');
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-dining/pdp-xdining.js